import React from "react";
import PropTypes from "prop-types";
import { OFFER_TYPES } from "app/constants";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";

class PriceChangedWarningMessage extends React.PureComponent {
	render() {
		const { newPrice, oldPrice, offerType, show = false } = this.props;

		const displayMessage = show && newPrice && oldPrice;

		let priceChangeWarning = false;

		if (displayMessage) {
			const priceChangedDelta = newPrice - oldPrice;

			if (priceChangedDelta > 0) {
				if (offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION) {
					priceChangeWarning = (
						<FormattedMessage
							id="error.payment.flight.price.changed.up.message"
							tagName="span"
							values={{
								amount: <AmountContainer amount={Math.abs(priceChangedDelta)} />,
							}}
						/>
					);
				} else {
					priceChangeWarning = (
						<FormattedMessage
							id="error.payment.price.changed.up.message"
							tagName="span"
							values={{
								amount: <AmountContainer amount={Math.abs(priceChangedDelta)} />,
							}}
						/>
					);
				}
			} else if (offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION) {
				priceChangeWarning = (
					<FormattedMessage
						id="error.payment.flight.price.changed.down.message"
						tagName="span"
						values={{
							amount: <AmountContainer amount={Math.abs(priceChangedDelta)} />,
						}}
					/>
				);
			} else {
				priceChangeWarning = (
					<FormattedMessage
						id="error.payment.price.changed.down.message"
						tagName="span"
						values={{
							amount: <AmountContainer amount={Math.abs(priceChangedDelta)} />,
						}}
					/>
				);
			}
		}

		return displayMessage ? <AlertMessage message={priceChangeWarning} /> : false;
	}
}

PriceChangedWarningMessage.propTypes = {
	show: PropTypes.bool,
	offerType: PropTypes.string,
	oldPrice: PropTypes.number,
	newPrice: PropTypes.number,
};

export default PriceChangedWarningMessage;
